import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ParametrizacionService } from '../../services/parametrizacion.service';
import { getErrorMessage, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import * as XLSX from 'xlsx';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-parametrizacion',
  templateUrl: './parametrizacion.component.html',
  styleUrls: ['./parametrizacion.component.scss']
})
export class ParametrizacionComponent implements OnInit {

  form: FormGroup
  pilotos: any = []
  excel:any = []

  columnsInfo: any[] = [
    { name: 'USUARIO', value: 'USUARIO' },
    { name: 'ID_ORIGEN', value: 'ID' },
    { name: 'DESCRIPCION', value: 'DESCRIPCIÓN' }
];

  columns: string[] = this.columnsInfo.map(value => { return value.name })

  displayedColumns: string[] = this.columns.concat(["EDICION"])

  constructor(
    private parametrizacionService:ParametrizacionService,
    private helpers: HelpersService,
    private notificationHelper: NotificationHelper,
    private dialog: MatDialog
    ) { }

  async ngOnInit() {
    this.helpers.setTitle("Prametrización de Pilotos");
    showSpinner()
    await this.loadPilotos()
    hideSpinner()
  }

  async loadPilotos() {
    showSpinner()
    try {
      const result = await this.parametrizacionService.getPilotos()
      this.pilotos = result.data.map((pilotos)=>{
        pilotos.ID_ORIGEN = pilotos.ID_ORIGEN.replace(/\D/g, '')
        return pilotos
      })
    } catch (error) {
      const message = getErrorMessage(error)
      this.notificationHelper.errorMessage(message)
    }
    hideSpinner()
  }

  async onSelectFile(e: HTMLInputElement) {
    showSpinner()
    const result: any = await this.xlsxtojson(e)
    result.forEach((parametro)=>{
      let dato = {
        c_emp : parametro.C_EMP,
        id_origen: `["${parametro.ID_ORIGEN}"]`,
        usuario: parametro.USUARIO
      }
      this.excel.push(dato)
    })
    hideSpinner();
  }

  async xlsxtojson(e) {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        const file = e.files;
        if (file && file.length) {
          const selectedFile = file[0]
          reader.readAsBinaryString(selectedFile)
          reader.onload = (e: any) => {
            let binaryData = e.target.result
            let workbook = XLSX.read(binaryData, { type: 'binary' })
            workbook.SheetNames.forEach(sheet => {
              resolve(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            })
          }
        } else {
          throw "No se seleccionó ningún archivo.";
        }
      } catch (error) {
        const message = getErrorMessage(error)
        this.notificationHelper.errorMessage(message)
      }
    })
  }

  async guardar(pilotos:any[]) {
    showSpinner()
    try {
      const result = await this.parametrizacionService.setPilotos(pilotos)
      if(result.success) {
        await this.loadPilotos()
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.notificationHelper.errorMessage(message)
    }
    hideSpinner()
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.pilotos);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'pilotos');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      var url = URL.createObjectURL(data);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName + EXCEL_EXTENSION);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
openModalOrigenPiloto(element): void {
    const dialogRef = this.dialog.open(ModalOrigenPiloto, {
      width: '256px',
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      this.guardar([{
        c_emp : result.C_EMP,
        id_origen: `["${result.ID_ORIGEN}"]`,
        usuario: result.USUARIO
      }])
    });
  }

}

@Component({
  selector: 'modal-origen-piloto',
  templateUrl: 'modal-origen-piloto.modal.html',
})
export class ModalOrigenPiloto implements OnInit {
  origenes: any = []
  origen_seleccionado:number
  constructor(
    public dialogRef: MatDialogRef<ModalOrigenPiloto>,
    private parametrizacionService:ParametrizacionService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  openModalOrigenPiloto(element): void {
    const dialogRef = this.dialog.open(ModalOrigenPiloto, {
      width: '256px',
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.guardar([{
      //   c_emp : result.C_EMP,
      //   id_origen: `["${result.ID_ORIGEN}"]`,
      //   usuario: result.USUARIO
      // }])
    });
  }

  async ngOnInit() {
    const result =  await this.parametrizacionService.getOrigenes()
    this.origenes = result.data
  }

}
